import { ElementType } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { ILoginViewProps } from 'APP/pages/authorization/Login/Login.types';
import { IllMCloud, IllMServer } from 'ASSETS/illustrations';
import { ProjectInstallationType } from 'CONFIG_TYPES';

export interface ILoginDestinationTypeStepProps extends ILoginViewProps {}

interface ILoginDestinationTypeStepPresenterParams extends ILoginDestinationTypeStepProps {}

type TLoginDestinationTypeStepItem = {
  type: ProjectInstallationType;
  title: string;
  description: string;
  Illustration: ElementType;
  onClick(): void;
};

interface ILoginDestinationTypeStepPresenter {
  items: TLoginDestinationTypeStepItem[];
}

export function useLoginDestinationTypeStepPresenter(
  params: ILoginDestinationTypeStepPresenterParams
): ILoginDestinationTypeStepPresenter {
  const { t } = useTranslation();

  const presenter = {
    get items(): TLoginDestinationTypeStepItem[] {
      return [
        {
          type: ProjectInstallationType.CloudOnly,
          title: t('auth_connection_method_cloud_title'),
          description: t('auth_connection_method_cloud_description'),
          onClick: params.loginPresenter.openRegionsDestinationsView,
          Illustration: IllMCloud,
        },
        {
          type: ProjectInstallationType.OnPremiseOnly,
          title: t('auth_connection_method_company_server_title'),
          description: t('auth_connection_method_company_server_description'),
          onClick: params.loginPresenter.openServersDestinationsView,
          Illustration: IllMServer,
        },
      ];
    },
  };
  return presenter;
}
